<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            查看帐务流水
          </div>
          <div style="display: none;">
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-thumb">指派中心
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-chat-line-square">
              用户催单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-tickets">工单跟进
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-delete">
              关闭工单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-copy">打印工单
            </el-button>
          </div>
        </div>

        <div>

          <div class="goodsStatus">
            <div v-for="(item, index) in goodsStatusList" :key="index">
              <div :class="{
											btnGoodsStatusBt1: goodsStatusIndex == index,
											btnGoodsStatusBt: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                <span>{{ item.name }}</span>
                <!--                <span class="num_color">{{ item.num }}</span>-->
              </div>
            </div>
          </div>
          <div>

            <div style="height: calc(100vh - 155px);">
              <vxe-table ref="filterTable" :data="details"
                         style="margin: 10px auto;" :stripe="true"
                         :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                         :row-config="{height: 30,isHover: true,padding: 0,}" :row-style="{ fontSize: '12px',  }"
                         show-overflow height="90%" :column-config="{ resizable: true }">
                <vxe-column type="seq" width="55">
                </vxe-column>

                <!-- <vxe-column field="itemCode" title="产品编码"/> -->
                <vxe-column field="dataType" title="数据类型" width="160"/>
                <vxe-column field="source" title="数据来源" width="160"/>
                <vxe-column field="invoicesNo" title="单据号" width="200"/>
                <vxe-column field="amount" title="金额" width="80"/>
                <vxe-column field="createBy" title="创建人" width="170"/>
                <vxe-column field="date" title="单据时间" width="180"/>
<!--                <vxe-column field="remark" title="备注"/>-->
              </vxe-table>
              <pager style="float: left" ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </div>
          </div>
        </div>
      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>

  </div>
</template>
<script>

import api from "@/api/projectApi";
import pager from "@/components/pager/index.vue";
import {siteMixins} from "@/mixins/tabChang";


export default {
  name: 'edit',
  mixins: [siteMixins],
  props: {
    _dataId: [String, Number],
    multiple: true,
    type: [String]
  },
  components: {
    pager

  },
  data() {
    return {
      goodsStatusList: [ //循环列表
        {name: "期初", num: 1},
        {name: "押金", num: 2},
        {name: "授信", num: 3},
        {name: "打款", num: 40},
        {name: "已占用", num: 5},
        {name: "已使用", num: 5},
        {name: "返厂核销", num: 5},
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个
      pageSizes: [50, 100, 500],
      details: [],
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        siteId: this._dataId,
        type: this.type ? this.type : '期初',
      },
      total: 0,


      value1: [],
      show3: false,
      node: true,

      showEdit: false,
      valuetype: 'model',
      activeName: 'first',
      activeName2: 'first',
      lan: 'zh_CN',

      tabIndex: 'first',
      dataId: '',
    }
  },
  computed: {

  },
  created() {
    console.log('_dataId', this._dataId)
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId

    for (let i = 0; i < this.goodsStatusList.length; i++) {
      if (this.type == this.goodsStatusList[i].name) {
        this.goodsStatusIndex = i
      }
    }

  },
  mounted() {
    this.getData();
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  methods: {

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getData();
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.$mask.open()

      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比
      console.log(this.goodsStatusIndex, 'this.goodsStatusIndex的值');

      this.requestParam.type = item.name
      this.getData()
      this.$mask.close()

    },



    getData() {
      this.$mask.open()

      console.log('getData', this.dataId)
      if (this.dataId && !isNaN(this.dataId)) {
        this.$http({
          url: api.partsBalance.getDetailsUrl,
          method: 'post',
          data: this.requestParam,
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data;
          this.details = data.records
          this.total = data.total
          console.log(data, 'data')
        })
      }
      this.$mask.close()

    },

  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .detail-wrap .d-cont .d-item {
  padding: 5px 0 !important;
}

.gather .el-tab-pane {
  margin-top: 10px;
  padding: 20px 0;

 >>>.el-tabs__active-bar {
    left: 20px !important;
  }

  .el-tabs__nav {
    margin-left: 20px !important;
  }
}

#containt .title b {
  margin-left: 0px !important;
}

::v-deep .product th:after {
  display: none !important;
}

::v-deep .product td {
  padding: 5px 0 !important;

}

::v-deep .vxe-table--render-default .vxe-cell {
  text-align: left !important;
}

.el-image {
  border: dashed 1px #e2e2e2;
  margin-right: 20px;
}

.undergo {
  ::v-deep .el-card.is-always-shadow {
    background-color: #f2f2f2;
    position: relative;
  }

  .el-timeline {
    background-color: #fff;
    padding-left: 10px !important;
    height: 100% !important;
  }

  .el-image {
    width: 60px !important;
    height: 60px !important;
  }

}

::v-deep .el-select__tags > span {
  display: flex !important;;
}

// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}
</style>
